import { ExternalRedirectRoute } from '../Routing/types';
const redirects: ExternalRedirectRoute[] = [
  {
    path: '/contact',
    externalRedirectTo: {
      'en-US': 'https://dtbaen.zendesk.com/hc/en-us',
      'pl-PL': 'https://faq.dieta.hpba.pl/hc/pl',
    },
  },
];

export default redirects;
